<template>
<v-flex class="py-3 px-2" xs12 sm8 md6 lg4>
  <div v-if="loading" class="py-5 text-xs-center"><div class="my-5 py-5"><div class="my-5 py-5">
    <v-progress-circular color="accent" indeterminate></v-progress-circular>
  </div></div></div>
  <v-card v-else class="pa-3 elevation-10">
    <v-form v-model="valid" @submit.prevent="resetPassword">
      <v-layout row wrap justify-center>
        <v-flex class="text-xs-center" xs12>
          <v-btn to="/sign-in" color="error" flat>
            <span>Cancel</span>
          </v-btn>
        </v-flex>
        <v-flex xs12>
          <v-text-field  
            label="E-mail"
            v-model.trim="email"
            prepend-icon="mail"
            :rules="emailRules"
            autofocus
            required
          ></v-text-field>
        </v-flex>
        <v-flex class="text-xs-center" xs8>
          <v-btn :loading="sending" :disabled="!valid || sending" color="success" type="submit" large block depressed>
            <span>Send Reset Email</span>
          </v-btn>
        </v-flex>
      </v-layout>  
    </v-form>
  </v-card>
</v-flex>
</template>

<script>
export default {
  data: () => ({
    loading: true,
    valid: false,
    sending: false,
    email: '',
    emailRules: [
      v => !!v || 'Please enter an email',
      v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Invalid email'
    ]
  }),
  beforeMount () {
    this.load()
  },
  methods: {
    load () {
      let appMsg = {
        type: 'error',
        msg: ''
      }
      if (this.$store.getters.user) {
        appMsg.msg = 'You are already signed in'
        this.$store.dispatch('showAppMsg', appMsg)
        this.$router.push('/')
      } else this.loading = false
    },
    resetPassword () {
      this.sending = true
      this.$store.dispatch('passwordReset', this.email).then(() => {
        let appMsg = {
          type: 'success',
          msg: 'Password reset email sent!'
        }
        this.$store.dispatch('showAppMsg', appMsg)
        this.sending = false
      }).catch((err) => {
        let appMsg = {
          type: 'error',
          msg: err.code === 'auth/user-not-found' ? 'User not found' : err.code
        }
        this.$store.dispatch('showAppMsg', appMsg)
        this.sending = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/auth/PasswordReset.vue